import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const constituentsApi = createApi({
  reducerPath: "constituentsApi",
  baseQuery,
  tagTypes: ["Constituents"],
  endpoints: (builder) => ({

    getConstituentsById: builder.query({
      query: ({id}) => `export/product/consituents/${id}`,
      transformResponse: (response) => {
        const data = response?.data ?? [];
        // Ensure it's always an array
        const normalized = Array.isArray(data) ? data : [data];

        // Add `id` field from exportEntityId
        return normalized.map((item) => ({
          ...item,
          id: item.consituentsId, 
        }));
      },
      providesTags: ["Constituents"],
    }),



    createConstituent: builder.mutation({
      query: ({id , ...data}) => ({
        url: `/export/product/consituents/${id}`,
        method: "PUT", 
        body: { Consituents:data },
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["Constituents"],
    }),



    updateConstituent: builder.mutation({
      query: ({ id ,subId , ...data  }) => ({
        url: `/export/product/consituents/${id}/${subId}`,
        method: "PUT",
        body: { consituents:data},
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["Consituents"],
    }),

    deleteConstituent: builder.mutation({
      query: ({ id }) => ({
        url: `/export/product/consituents/${id}`,
        method: "DELETE",
        headers: {
          "X-Request-Id":`${Date.now()}`,
        },
      }),
      invalidatesTags: ["Constituents"],
    }),

  }),
});

export const {
  useLazyGetConstituentsByIdQuery,
  useCreateConstituentMutation,
  useUpdateConstituentMutation,
  useDeleteConstituentMutation,
} = constituentsApi;
